import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class transferenciaService {

    //----> Queries

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdfTicket(filter) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }


    async listarEstado() {
        const response = await axios
            .get(`${ERP}logistica/transferencia/estado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}logistica/transferencia/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    //----> Commands 

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/transferencia`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/transferencia`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/transferencia/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async aprobar(data) {
        const response = await axios
            .put(`${ERP}logistica/transferencia/aprobar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new transferenciaService();